import UIkit from 'uikit';
import 'magnific-popup';
import autosize from 'autosize';

if (window.wpforms) {
    window.wpforms.scrollToError = function () {
    };
}

$.extend(true, $.magnificPopup.defaults, {
    tLoading: 'Завантаження...', // Text that is displayed during loading. Can contain %curr% and %total% keys
});

function showDialogForm(id) {
    $.magnificPopup.open({
        items: {
            // eslint-disable-next-line no-undef
            src: sage.ajax_url,
            type: 'ajax',
        },
        ajax: {
            settings: {
                type: 'POST',
                data: {action: 'wpforms_display', form_id: id},
            },
        },
        callbacks: {
            ajaxContentAdded: function () {
                const textarea = UIkit.util.$('textarea', this.content[0]);

                window.wpforms.init()
                autosize(textarea);
            },
        },
    });
}

export default function () {
    const callback = UIkit.util.$$('.js-callback');
    const contact = UIkit.util.$$('.js-contact');


    UIkit.util.on(callback, 'click', function () {
        showDialogForm(1122);
    });

    UIkit.util.on(contact, 'click', function () {
        showDialogForm(1120);
    });
}






// WEBPACK FOOTER //
// ./scripts/tourism/forms.js